module.exports = __webpack_public_path__ + "static/media/logo-tw.4643ca5f.png";